import { createSlice } from '@reduxjs/toolkit';

import type { SubmissaoStepState } from '@/features/processo-arbitral/types/submissaoStepTypes';

import { fetchProcessoInicioFluxoStatus, submitProcessoArbitral } from './actions';

const initialState: SubmissaoStepState = {
  isSubmitting: false,
  error: null,
  errorCode: null,
  lastSubmittedProcesso: null,
  inicioFluxoStatus: null,
  isLoadingInicioFluxo: false,
};

const submissaoStepSlice = createSlice({
  name: 'processoArbitralSubmissaoStep',
  initialState,
  reducers: {
    resetSubmissaoStepState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitProcessoArbitral.pending, (state) => {
        state.isSubmitting = true;
        state.error = null;
        state.errorCode = null;
      })
      .addCase(submitProcessoArbitral.fulfilled, (state, action) => {
        state.isSubmitting = false;
        state.lastSubmittedProcesso = action.payload;
      })
      .addCase(submitProcessoArbitral.rejected, (state, action) => {
        state.isSubmitting = false;
        state.error = action.payload?.message || 'Erro ao enviar arbitragem';
        state.errorCode = action.payload?.code ?? null;
      })
      .addCase(fetchProcessoInicioFluxoStatus.pending, (state) => {
        state.isLoadingInicioFluxo = true;
        state.inicioFluxoStatus = null;
      })
      .addCase(fetchProcessoInicioFluxoStatus.fulfilled, (state, action) => {
        state.isLoadingInicioFluxo = false;
        state.inicioFluxoStatus = action.payload;
      })
      .addCase(fetchProcessoInicioFluxoStatus.rejected, (state) => {
        state.isLoadingInicioFluxo = false;
        state.inicioFluxoStatus = null;
      });
  },
});

export const { resetSubmissaoStepState } = submissaoStepSlice.actions;
export const submissaoStepReducer = submissaoStepSlice.reducer;
